var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length > 1)?_c('div',{staticStyle:{"max-width":"130px"}},[_c('v-select',{attrs:{"outlined":"","items":_vm.items,"hide-details":"","dense":""},on:{"change":_vm.onChange},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }